import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Table, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './Styles.css';

function Consumption({ SN, Combinations }) {
    const { t } = useTranslation();


    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "70%",
            icon: null,
            title: t("Consumption"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("Daily Load (kWh)"), dataIndex: "EDayLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Monthly Load (kWh)"), dataIndex: "EMonthLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Yearly Load (kWh)"), dataIndex: "EYearLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Total Load (kWh)"), dataIndex: "ETotalLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},

                ]}
                summary={(data) => {
                    if (!data || data.length < 2) {
                        return null;
                    }
                    let EDayLoad = 0;
                    let EMonthLoad = 0;
                    let EYearLoad = 0;
                    let ETotalLoad = 0;
                    data.forEach((item, index) => {
                        if (item.EDayLoad != null ) {
                            let v = parseInt(item.EDayLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayLoad += v * 0.01;
                        }
                        if (item.EMonthLoad != null ) {
                            let v = parseInt(item.EMonthLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthLoad += v * 0.01;
                        }
                        if (item.EYearLoad != null ) {
                            let v = parseInt(item.EYearLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearLoad += v * 0.01;
                        }
                        if (item.ETotalLoad != null ) {
                            let v = parseInt(item.ETotalLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalLoad += v * 0.01;
                        }
                    });
                    return (
                        <>
                            <Table.Summary.Row style={{fontWeight:"bold"}}>
                                <Table.Summary.Cell index={0} colSpan={2} align='right'>{t("Subtotal")}</Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>{EDayLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{EMonthLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{EYearLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{ETotalLoad.toFixed(2)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                dataSource={Combinations}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    let EDayLoad = 0;
    let ETotalLoad = 0;
    let count = Combinations?.length || 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            if (item.EDayLoad != null ) {
                let v = parseInt(item.EDayLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDayLoad += v * 0.01;
            }
            if (item.ETotalLoad != null ) {
                let v = parseInt(item.ETotalLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotalLoad += v * 0.01;
            }
        });
    }
    

    return (<div className="combination-stats-block">
        <div className="title" style={{ backgroundColor: '#6fad92' }}>
            {t('Consumption')}
            <Button ghost size='small' shape="round" onClick={handleClick}>{t("Details")}</Button>
        </div>
        <div className="content" >
            <div className="left">
                <img src="images/inverter/load.png" alt={t('Load')}></img>
            </div>
            <div className="right">
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {EDayLoad.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Load')}</div>
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {ETotalLoad.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Load')}</div>
            </div>
        </div>
    </div>);
}

export default Consumption;